<div class="main-school-details-registration-under-verification">
  <div class="sub-container-registration-under-verification">
    <div class="slider">
      <app-slider></app-slider>
    </div>
    <div class="content-for-registration">
      <div class="help-link-registration">
        <div class="headerbar-right">
          <app-language-dropdown></app-language-dropdown>
          <a class="link-for-contact-registration" data-toggle="modal" data-target="#logout">
            {{ 'logout' | translate }}</a>
        </div>
      </div>
      <div class="content-for-school-details-registration-under-verification">
        <ng-container *ngIf="!isVerified; else verifiedContent">
          <div class="under-verification-container">
            <div class="under-verification-first-image">
              <img src="images_ext/underVerification.svg" alt="logo" />
            </div>
            <div class="under-verification-title">
              {{ 'underVerification' | translate }}
            </div>
            <div class="second-under-verification-title" [innerHTML]="'underVerificationMessage'| translate"></div>
            <div class="submit-container">
              <button class="registration-ok-btn" (click)="underVerification()">
                {{ 'okay' | translate }}
              </button>
            </div>
          </div>
        </ng-container>
        <ng-template #verifiedContent>
          <div class="verification-success-container">
            <div class="card">
              <div class="under-verification-message">
                {{ 'underVerificationMessagesecond' | translate }}
              </div>
              <div class="container">
                <div class="profile-image-container">
                  <div class="profile-placeholder">
                    <img class="placeholder-image" src="{{ schoolImage }}" [alt]="'editProfile' | translate" />
                  </div>
                  <div class="edit-icon" (click)="triggerFileInput()">
                    <img src="images_ext/edit-profile.svg" alt="Edit Icon" class="edit-image" />
                  </div>
                  <input type="file" class="input-style" accept="image/*" #fileInput hidden
                    (change)="onFileSelected($event)" />
                </div>
                <div class="wisdom-group">{{ schoolName }}</div>
                <div class="mobile-container">
                  <div class="mobile-icon">
                    <img src="images_ext/mobileIcon.svg" alt="Mobile Icon" />
                  </div>
                  <div class="mobile-number">
                    <div class="mobile-country-code">{{ countryCode }}</div>
                    <div class="mobile-digits">{{ schoolPhoneNumber }}</div>
                  </div>
                </div>
                <div class="gmail-container">
                  <div class="gmail-icon">
                    <img src="images_ext/gmail-icon.svg" alt="Gmail Icon" />
                  </div>
                  <div class="gmail-address address-color">
                    {{ schoolEmailId }}
                  </div>
                </div>
                <div class="address-container">
                  <div class="address-icon">
                    <img src="images_ext/address-icon.svg" alt="Address Icon" />
                  </div>
                  <div class="address">{{ schoolAddress }}</div>
                </div>
              </div>
            </div>
            <div *ngIf="showGradientCard" class="gradient-card">
              <div class="gradient-card-content">
                <div class="review-profile" [innerHTML]="'teamReviewingProfile' | translate"></div>
              </div>
              <div class="cont-btn-container">
                <button class="not-interested-btn" (click)="notInterested()">
                  {{ 'notInterested' | translate }}
                </button>
                <button class="continue-btn" data-toggle="modal" data-target="#questionArray"
                  (click)="handleContinue()">{{ 'continue' | translate
                  }}</button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="questionArray" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
  aria-hidden="true" *ngIf="questionArrayList.length">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="btn-skip btn btn-secondary pull-right" data-dismiss="modal"
        (click)="handleSkip()">{{ 'skip' | translate }}</button>
      <div class="modal-header">
        <div class="modal-title" id="simpleModalLabel">{{ questionArrayList[currentQuestionIndex]?.question }}</div>
      </div>
      <div class="modal-body answer-container">
        <textarea name="answer" id="" class="answer" [placeholder]="'enterYourAnswer' | translate"
          [(ngModel)]="answer"></textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn prev-btn" (click)="prevQuestion()" [disabled]="isPrevBtnClicked">
          <ng-container *ngIf="isPrevBtnClicked; else notLoadingLeftArrow">
            <app-button-loader></app-button-loader>
          </ng-container>
          <ng-template #notLoadingLeftArrow>
            <img src="../../assets/img/arrow-left.svg" alt="left-arrow" class="right-arrow-img" />
          </ng-template>
        </button>
        <div class="text-center question-number">{{ currentQuestionIndex + 1 }}/{{ questionArrayList.length }}</div>
        <button type="button" class="btn next-btn" (click)="nextQuestion()" [disabled]="isNextBtnClicked">
          <ng-container *ngIf="isNextBtnClicked; else notLoadingRightArrow">
            <app-button-loader></app-button-loader>
          </ng-container>
          <ng-template #notLoadingRightArrow>
            <img src="../../assets/img/arrow-right.svg" alt="right-arrow" class="right-arrow-img" />
          </ng-template>
        </button>
      </div>
    </div>
  </div>
</div>

<app-logout-modal></app-logout-modal>